import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconCar8: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCar8"><Path d="M4.25 17.5H1.5V4.5H16.5L22.5 9.5V17.5H19.75" stroke="currentColor"/><Circle cx="7" cy="17" r="2.5" stroke="currentColor"/><Circle cx="17" cy="17" r="2.5" stroke="currentColor"/><Path d="M9.75 17.5H14.25" stroke="currentColor"/></CentralIconBase>;
});

export default IconCar8;
